const googleMapURI = "https://maps.googleapis.com/maps/api";
const googleMapKey = "AIzaSyDG0K2LtAsboyYYP387GUCfFGUH3lD_cfU";

export default {
  googleMapURL: `${googleMapURI}/js?key=${googleMapKey}&v=3.exp&libraries=geometry,places`,
};



// WEBPACK FOOTER //
// ./src/config/application.js